module.exports = __webpack_public_path__ + "img/bg_avatar_male_15.8db210c1.png";